module.exports = __webpack_public_path__ + "static/media/search.331d3852.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/search.svg
// module id = 82
// module chunks = 0